import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import MaterialComponent from "./MaterialComponent";
import Spinner from "../../sample/spinner";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import Chip from "@material-ui/core/Chip";
import Latex from "./Latex";


class ProjectAssesment extends Component {
  constructor(props) {
    super(props);
    const projectlist = [];
    const saveprojectlist = [];
    this.state = {
      contentType: props.contentType,
      contentId: props.contentId,
      modalIsOpen: false,
      secondModalIsOpen: false,
      projectlist,
      saveprojectlist,
      answertext: "",
      description: "",

      projecttitle: "",
      selectedAnsFile: null,
      showComponent: false,

      loading: false,
      viewFilepath: "",
      uploadedviewFilepath: ""
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openSecondModal = this.openSecondModal.bind(this);
    this.closeSecondModal = this.closeSecondModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  openModal(path) {
    this.setState({ modalIsOpen: true, viewFilepath: path });
  }

  closeModal() {
    this.setState({ modalIsOpen: false, viewFilepath: "" });
  }

  openSecondModal(path) {
    this.setState({
      secondModalIsOpen: true,
      uploadedviewFilepath: path
    });
  }

  closeSecondModal() {
    this.setState({ secondModalIsOpen: false, uploadedviewFilepath: "" });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId
    ) {
      this.setState({
        contentType: this.props.contentType,
        contentId: this.props.contentId,
      });

      if (this.props.contentType === "Topiclevel") {
        this.getprojectdata();
      } else {
        // this.getUnitMcq();
      }
    }
  }

  componentDidMount() {
    this.getprojectdata();
  }
  async getprojectdata() {
    this.setState({ showComponent: true });
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topic", this.props.contentId);
    // formData.append("topic", this.props.contentId);
    axios
      .post("LearnerAssignment/getProjassignment", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            projectlist: res.data.projectlist,

            showComponent: false,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  handleChange(event) {
    // console.log(event.target.value)
    // console.log("this.state.answertext = "+ this.state.answertext)
    let name = event.target.name;
    let val = event.target.value;
    this.setState({ [name]: val });
  }
  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  handleSubmit(e, assoffid, prevans) {
    e.preventDefault();
    this.saveproject(assoffid, prevans);
  }

  async saveproject(assoffid, prevans) {
    this.setState({ loading: true });
    if (this.state.selectedAnsFile) {
      let filename = this.state.selectedAnsFile.name.split(".").pop();
      if (
        filename !== "pdf" &&
        filename !== "jpg" &&
        filename !== "xls" &&
        filename !== "jpeg" &&
        filename !== "xlsx" &&
        filename !== "docx" &&
        filename !== "doc" &&
        filename !== "txt"
      ) {
        // console.log("upload only" + filename);
        toast.error(" upload only pdf/jpg/jpeg/docx/txt/xlsx files");
        await this.sleep(3000);
        this.setState({ loading: false });
        return;
      }
    }
    // console.log("prevans  ==" + prevans);
    // console.log("this.state.answertext 2  ==" +this.state.answertext);
    if ((this.state.answertext == "" || this.state.answertext == null) && prevans == "") {
      toast.error("Enter Answer");
      await this.sleep(3000);
      this.setState({ loading: false });
      return;
    } else {
      var formData = new FormData();
      if (this.state.answertext != "") {
        formData.append("desc", this.state.answertext);
      } else {
        formData.append("desc", prevans);
      }

      formData.append("assfile", this.state.selectedAnsFile);
      formData.append("assoff", assoffid);
      formData.append("projecttitle", this.state.projecttitle);


      axios
        .post("LearnerAssignment/saveProjectAssignment", formData)

        .then((res) => {
          if (res.data.status === "200" || res.data.status === "100") {
            this.setState({
              loading: false,
              projectlist: res.data.saveprojectlist,
            });
            toast.success(res.data.msg);
            // window.location.reload(false);
          } else {
            toast.error("Something went wrong");
          }
        }).catch((error) => {
          let msg = "";
          if (error.response) {
            msg = "Something went wrong.";
          } else if (error.request) {
            msg = "Please try again.";
          } else {
            msg = "Un-expected error.";
          }
          toast.error(msg, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        });
    }
  }

  render() {
    return (
      <div>
        {this.state.showComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          ""
        )}
        <div class="row">
          <div className="col-lg-6">
            <Chip
              label="Project"
              variant="outlined"
              className="ft-size"
              color="primary"
            />
          </div>
        </div>
        <br />
        <div id="style-6" class="scrollmcq">
          {this.state.projectlist.map((item, indexitem) => (
            <>
              <div class="card p-3 mb-2">
                <div class="row">
                  <div class=" col-md-9 col-lg-9 text-left">
                    {item.srno} ) &nbsp;
                    <label for={item.assignmenttext}>
                      <Latex><span
                        dangerouslySetInnerHTML={{
                          __html: item.assignmenttext,
                        }}
                      /></Latex>
                    </label>
                  </div>
                  <div class="col-lg-3 col-md-3 text-right">
                    {item.weightage === null || item.weightage === 0 ? (
                      <>
                        <Chip
                          label="Non Graded "
                          className="ft-size"
                        />
                      </>
                    ) : (
                      <>
                        <Chip
                          label={"weightage :" + item.weightage}
                          className="ft-size"
                        />
                      </>
                    )}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    {item.assignmentpath !== null ? (
                      <>
                        <Link onClick={(e) => this.openModal(item.assignmentpath)}>
                          <FontAwesomeIcon icon={faDownload} /> &nbsp;&nbsp; Project
                          Attachment{" "}
                        </Link>
                        {/* <Modal
                      isOpen={this.state.modalIsOpen}
                      onRequestClose={this.closeModal}
                      size="lg"
                      style={{
                        top: "0%",
                        left: "0%",
                        right: "0%",
                        bottom: "0%",
                        maxWidth: "1600px",
                        width: "60%",
                        height: "100%",
                      }}
                    >
                      <ModalHeader toggle={this.closeModal}></ModalHeader>
                      <ModalBody>
                        <div>{item.assignmentpath}
                          <MaterialComponent
                            contentType="contenttype"
                            contentId="0"
                            materialid="0"
                            materialtype={item.assignmentpath.split(".").pop()}
                            materialpath={item.assignmentpath}
                          />
                        </div>
                      </ModalBody>
                      <ModalFooter></ModalFooter>
                    </Modal> */}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>{" "}
                {item.isprojectworksubmission === true ? (
                  <>
                    <div class="row">
                      <div class="col-sm-12">
                        <label></label>
                        <textarea
                          class="form-control"
                          name="isprojectass"
                          placeholder="Enter  Project Title"
                          id="isprojectass"
                          defaultValue={item.projecttitle}
                          onChange={(e) => this.setState({ projecttitle: e.target.value })}
                          // onChange={this.handleChange}
                          rows={3}
                          cols={120}
                          required=""
                        ></textarea>

                      </div>
                    </div>

                  </>) : (<>f </>)}
                <div class="row">
                  <div class="col-sm-12">
                    <label></label>
                    <textarea
                      class="form-control"
                      name="answertext"
                      placeholder="Enter Answer Text"
                      id="answertext"
                      defaultValue={item.answertext}
                      onChange={(e) => this.setState({ answertext: e.target.value })}
                      // onChange={this.handleChange}
                      rows={5}
                      cols={120}
                      required=""
                    ></textarea>


                  </div>
                </div>
                <br />
                <div class="row ">
                  <div class="col-sm-6">
                    <input
                      class="form-control"
                      id="selectedAnsFile"
                      type="file"
                      name="selectedAnsFile"
                      onChange={(e) =>
                        this.setState({
                          selectedAnsFile: e.target.files[0],
                        })
                      }
                    />
                  </div>
                  <div class="col-sm-6 text-right pt-1">
                    {item.answerfilepath !== null ? (
                      <>
                        <Link onClick={(e) => this.openSecondModal(item.answerfilepath)}>
                          <FontAwesomeIcon icon={faDownload} /> View
                          My Previous Submission{" "}
                        </Link>
                        {/* <Modal
                          isOpen={this.state.secondModalIsOpen}
                          onRequestClose={this.closeSecondModal}
                          size="lg"
                          style={{
                            top: "0%",
                            left: "0%",
                            right: "0%",
                            bottom: "0%",
                            maxWidth: "1600px",
                            width: "60%",
                            height: "60%",
                          }}
                        >
                          <ModalHeader
                            toggle={this.closeSecondModal}
                          ></ModalHeader>
                          <ModalBody>
                            <div>
                              <MaterialComponent
                                contentType="contenttype"
                                contentId="0"
                                materialid="0"
                                materialtype={item.answerfilepath
                                  .split(".")
                                  .pop()}
                                materialpath={item.answerfilepath}
                              />
                            </div>
                          </ModalBody>
                          <ModalFooter></ModalFooter>
                        </Modal> */}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div class="row ">
                  <div class="col-sm-12">
                    <p className="col-p">
                      ** The previous assignment file will be overwritten when you
                      submit a new file.
                    </p>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={this.state.loading}
                      onClick={(e) => this.handleSubmit(e, item.assignmentofferid, item.answertext)}
                    >
                      Submit
                    </Button>

                    {this.state.loading === true ? (
                      <CircularProgress
                        size={24}
                        color="green"
                        className="buttonProgress1"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </>
          ))}
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            size="lg"
            style={{
              top: "0%",
              left: "0%",
              right: "0%",
              bottom: "0%",
              maxWidth: "1600px",
              width: "60%",
              height: "100%",
            }}
          >
            <ModalHeader toggle={this.closeModal}></ModalHeader>
            <ModalBody>
              <div>
                <MaterialComponent
                  contentType="contenttype"
                  contentId="0"
                  materialid="0"
                  materialtype={this.state.viewFilepath.split(".").pop()}
                  materialpath={this.state.viewFilepath}
                />
              </div>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </Modal>
          <Modal
            isOpen={this.state.secondModalIsOpen}
            onRequestClose={this.closeSecondModal}
            size="lg"
            style={{
              top: "0%",
              left: "0%",
              right: "0%",
              bottom: "0%",
              maxWidth: "1600px",
              width: "60%",
              height: "60%",
            }}
          >
            <ModalHeader
              toggle={this.closeSecondModal}
            ></ModalHeader>
            <ModalBody>
              <div>
                <MaterialComponent
                  contentType="contenttype"
                  contentId="0"
                  materialid="0"
                  materialtype={this.state.uploadedviewFilepath
                    .split(".")
                    .pop()}
                  materialpath={this.state.uploadedviewFilepath}
                />
              </div>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ProjectAssesment;
